import { render, staticRenderFns } from "./AddDiscipleshipGroupModal.vue?vue&type=template&id=6913b5ab&"
import script from "./AddDiscipleshipGroupModal.vue?vue&type=script&lang=js&"
export * from "./AddDiscipleshipGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports